import React from 'react';

export default function BackgroundGrid({
                                           gridSize    = '24px',
                                           gridColor   = 'rgb(116,103,255)',
                                           opacity     = 0.1,
                                           fadeOffset  = 0.6,
                                       }) {
    const gradients = [
        `linear-gradient(to right, ${gridColor} 1px, transparent 1px)`,
        `linear-gradient(to bottom, ${gridColor} 1px, transparent 1px)`,
    ].join(', ');

    const fadeStyles =
        fadeOffset > 0 && fadeOffset < 1
            ? {
                maskImage:       `radial-gradient(ellipse at center, black ${fadeOffset * 100}%, transparent 100%)`,
                WebkitMaskImage: `radial-gradient(ellipse at center, black ${fadeOffset * 100}%, transparent 100%)`,
            }
            : {};

    return (
        <div
            aria-hidden="true"
            className="absolute inset-0 w-full h-full z-0 pointer-events-none"
            style={{
                backgroundImage: gradients,
                backgroundSize:   `${gridSize} ${gridSize}`,
                opacity,
                ...fadeStyles,
            }}
        />
    );
}
